import React from "react";

const levels = ["Expert", "Proficient", "Intermediate"];

export default function Skills() {
  const skillCategories = [
    {
      title: "Programming Languages",
      skills: [
        { name: "C#", level: "Expert", proficient: true },
        { name: "SQL", level: "Expert", proficient: true },
        { name: "HTML/CSS", level: "Expert", proficient: true },
        { name: "TypeScript", level: "Intermediate", proficient: false },
        { name: "JavaScript", level: "Intermediate", proficient: false },
        { name: "VB.NET", level: "Proficient", proficient: true }
      ]
    },
    {
      title: ".NET",
      skills: [
        { name: "ASP.NET Core (.NET 6/7/8)", level: "Expert", proficient: true },
        { name: "Blazor & Razor", level: "Expert", proficient: true },
        { name: "Entity Framework Core", level: "Expert", proficient: true },
        { name: "REST & Minimal APIs", level: "Expert", proficient: true },
        { name: "ASP.NET Core Identity", level: "Proficient", proficient: true },
        { name: "MVC & .NET Framework", level: "Proficient", proficient: true }
      ]
    },
    {
      title: "Cloud & DevOps",
      skills: [
        { name: "Microsoft Azure", level: "Proficient", proficient: true },
        { name: "Azure DevOps", level: "Proficient", proficient: true },
        { name: "CI/CD Pipelines", level: "Proficient", proficient: true },
        { name: "Git/GitHub", level: "Proficient", proficient: true },
        { name: "AWS", level: "Intermediate", proficient: false }
      ]
    },
    {
      title: "Data & Reporting",
      skills: [
        { name: "MS SQL Server", level: "Expert", proficient: true },
        { name: "Power BI", level: "Proficient", proficient: true },
        { name: "Power Query (M)", level: "Proficient", proficient: true },
        { name: "DAX", level: "Proficient", proficient: true }
      ]
    },
    {
      title: "Front End",
      skills: [
        { name: "Blazor", level: "Expert", proficient: true },
        { name: "Telerik UI", level: "Proficient", proficient: true },
        { name: "React", level: "Intermediate", proficient: false },
        { name: "Angular", level: "Intermediate", proficient: false }
      ]
    }
  ];

  return (
    <div className="mx-auto max-w-page px-5 py-16 md:px-10 md:py-24">
      <div className="grid gap-6 border-b border-ink pb-4 md:grid-cols-12 md:items-end">
        <h2 className="display font-serif text-4xl font-semibold tracking-tight md:col-span-6 md:text-6xl">
          Skills
        </h2>
        <p className="max-w-md text-base leading-snug text-ink-soft md:col-span-5 md:col-start-8">
          Grouped by how much production work sits behind each one, not by how recently it was learned.
        </p>
      </div>

      <div className="hidden grid-cols-12 gap-8 border-b border-ink/25 py-3 md:grid">
        <p className="label col-span-3 text-ink-soft">02 / Area</p>
        {levels.map((level) => (
          <p key={level} className="label col-span-3 text-ink-soft">
            {level}
          </p>
        ))}
      </div>

      {skillCategories.map((category) => (
        <div
          key={category.title}
          className="grid gap-4 border-b border-ink/25 py-6 md:grid-cols-12 md:gap-8"
        >
          <h3 className="font-serif text-2xl font-semibold italic md:col-span-3 md:text-xl">
            {category.title}
          </h3>
          {levels.map((level) => {
            const names = category.skills
              .filter((skill) => skill.level === level)
              .map((skill) => skill.name);
            return (
              <div key={level} className={`md:col-span-3 ${names.length ? "" : "hidden md:block"}`}>
                <p className="label mb-1 text-ink-soft md:hidden">{level}</p>
                {names.length ? (
                  <ul className={level === "Expert" ? "font-semibold" : ""}>
                    {names.map((name) => (
                      <li key={name} className="text-lg leading-snug">
                        {name}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span className="font-mono text-ink-soft/50" aria-hidden="true">—</span>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
